function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 24.59c6.63 0 12-5.37 12-12s-5.37-12-12-12-12 5.37-12 12 5.37 12 12 12z",
  fill: "#0D7C67"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.15 11.69v1.03h-1.79v.44h1.79v1.03h-1.79c-.06 2.72-2.42 4.91-5.12 4.91-2.72 0-5.1-2.17-5.13-4.91h-1.8v-1.03H7.1v-.44H5.31v-1.03H7.1v-1.63c0-1.09-1.09-1.31-1.49-1.31v-.51h2.76v5.89c0 2.49 2.26 3.7 3.86 3.7s3.88-1.53 3.88-3.65V8.24h2.71v.51c-.98 0-1.47.77-1.47 1.25v1.68c.01.01 1.8.01 1.8.01zm-3.61 2.11c0 1.28-.87 3.52-3.31 3.52S8.9 15.13 8.9 13.8V8.24h2.89v.54c-.27 0-1.52.05-1.52 1.36 0 0-.02 2.04-.02 3.61 0 1.72 1.11 2.1 1.86 2.1.74 0 2.02-.31 2.02-2.05v-3.72c0-.65-.38-1.3-1.48-1.3v-.54h2.89v5.56z",
  fill: "#fff"
});

function SvgUsdu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "71a1abbbb95dcb6f2c92182c80834df8.svg";
export { SvgUsdu as ReactComponent };